module.exports = __webpack_public_path__ + "img/rank_2.f1b1fb42.png";